// extracted by mini-css-extract-plugin
export default {"mainError":"Error_mainError__2FtXv","backButton":"Error_backButton__46NIl"};